import Skeleton from "react-loading-skeleton";

import PendingStatus from "~/components/ui/pendingStatus/PendingStatus";

import styles from "./Subscription.module.scss";
import { SavedCardStatus } from "./useSavedCardRecheck";

const paymentMethodsHeader = ["Card type", "Status", "Expiry date"];
type PaymentMethodsProps = {
  "Card type": JSX.Element;
  Status: JSX.Element;
  "Expiry date": JSX.Element;
};

const PaymentMethods = ({
  data,
  isFetching = false,
  savedCardStatus = null,
  isAwaitingCard = false,
}: {
  data: PaymentMethodsProps[] | null;
  // While loading, "N/A" would read as "no card".
  isFetching?: boolean;
  // Back from Stripe: the saved card, until billing shows it.
  savedCardStatus?: SavedCardStatus;
  // A card awaited elsewhere (the trial's, the block's): said in place of
  // "N/A", never over a card shown.
  isAwaitingCard?: boolean;
}) => {
  const isSaving =
    !isFetching &&
    (savedCardStatus === "saving" || (isAwaitingCard && !data?.length));

  return (
    // @ts-expect-error TS2339 non-existing className
    <table className={styles.table}>
      <thead>
        <tr>
          {paymentMethodsHeader?.map((header) => (
            <th key={header}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {isFetching && (
          <tr>
            {paymentMethodsHeader.map((header) => (
              <td key={header}>
                <Skeleton width={100} />
              </td>
            ))}
          </tr>
        )}
        {isSaving && (
          <tr>
            <td colSpan={paymentMethodsHeader.length}>
              <PendingStatus>Saving your card…</PendingStatus>
            </td>
          </tr>
        )}
        {!isFetching && !isSaving && (!data || data.length === 0) && (
          <tr>
            <td colSpan={paymentMethodsHeader.length}>N/A</td>
          </tr>
        )}
        {!isFetching &&
          !isSaving &&
          data?.map((row: { [key: string]: JSX.Element }, index: number) => (
            <tr key={index}>
              {paymentMethodsHeader?.map((header) => (
                <td key={header}>{row?.[header]}</td>
              ))}
            </tr>
          ))}
        {!isFetching && !isSaving && savedCardStatus === "slow" && (
          <tr>
            <td colSpan={paymentMethodsHeader.length}>
              Card saved. It may take a minute to show up.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
export default PaymentMethods;
